<template>
  <el-select
    v-model="value"
    multiple
    placeholder="All"
    @update:modelValue="update"
  >
    <el-option
      v-for="item in platformOptions"
      :key="item.key"
      :label="item.label"
      :value="item.key"
    />
  </el-select>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue'
import { Platform, PlatformLabel, PlatformLabels } from '@/api/types'

type PlatformEntry = {
  key: Platform
  label: string
  disabled: boolean
}

export default defineComponent({
  name: 'PlatformSelect',
  props: {
    modelValue: {
      type: Array,
      required: true
    }
  },
  setup(props, context) {
    const value = ref(props.modelValue)
    const platformOptions = PlatformLabels.map<PlatformEntry>(
      (platformLabel: PlatformLabel) => {
        return {
          key: platformLabel.type_id,
          label: platformLabel.label,
          disabled: false
        }
      }
    )

    const update = (newValue: Array<Platform>) => {
      context.emit('update:modelValue', newValue)
    }
    watch(
      () => props.modelValue,
      (newVal) => {
        value.value = newVal
      }
    )
    return { update, platformOptions, value }
  }
})
</script>
